import React, { useEffect, useState, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useForm } from "react-hook-form";
import VehicleTypeService from "../../services/VehicleTypeService";
import Breadcrumb from "../../components/Breadcrumb";
import StorageService from "../../services/StorageService";
import MessageDialog from "../../components/MessageDialog";


export default function AddVehicleType() {
  const [loading, setLoading] = useState(false);
  const [editLoading, setEditLoading] = useState(false);
  const [message, setMessage] = useState("");
  const [msgType, setMsgType] = useState("");
  const [editMode, setEditMode] = useState(false);
  const [editId, setEditId] = useState(null);
  // const messageTimer = useRef(null);
  const navigate = useNavigate();
  const { id } = useParams();

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  // Load mode (Add or Modify)
  useEffect(() => {
    if (id) {
      setEditMode(true);
      setEditId(id);
      fetchVehicleTypeById(id);
    } else {
      setValue("status", "Active");
    }
  }, [id]);

  const fetchVehicleTypeById = async (vehicleTypeId) => {
    try {
      setEditLoading(true); // 🔄 start spinner

      const res = await VehicleTypeService.getById(vehicleTypeId);

      if (res?.data) {
        const record = res.data;
        setValue("vehicleType", record.vehicleType || "");
      } else {
        showMessage("Failed to load Vehicle Type.", "error");
      }
    } catch (error) {
      console.error(error);
      showMessage("Error fetching Vehicle Type details.", "error");
    } finally {
      setEditLoading(false);
    }
  };

  const showMessage = (text, type = "error") => {
    setMessage(text);
    setMsgType(type);
    // if (messageTimer.current) clearTimeout(messageTimer.current);
    // messageTimer.current = setTimeout(() => setMessage(""), 4000);
  };

  // const closeMessage = () => {
  //   setMessage("");
  //   if (messageTimer.current) clearTimeout(messageTimer.current);
  // };

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      let res;

      if (editMode && editId) {
        data.updatedBy = StorageService.loginData().employeeId;
        res = await VehicleTypeService.update(editId, data);
      } else {
        data.createdBy = StorageService.loginData().employeeId;
        res = await VehicleTypeService.create({ ...data, status: "Active" });
      }

      console.log("Save Response:", res);

      if (
        res?.message &&
        res.message.toLowerCase().includes("exists")
      ) {
        showMessage("Duplicate Vehicle Type Name!", "error");
        return;
      }

      if (res?.status || res?.id || res?.data) {
        showMessage(
          editMode
            ? "Vehicle Type updated successfully."
            : "Vehicle Type added successfully.",
          "success"
        );

        setTimeout(() => {
          navigate("/cpnl/vehicletype/view");
        }, 1000);
      } else if (
        res?.message &&
        res.message.toLowerCase().includes("duplicate")
      ) {
        showMessage("Duplicate Vehicle Type Name!", "error");
      } else {
        showMessage("Failed to save Vehicle Type.", "error");
      }
    } catch (error) {
      console.error("Error saving Vehicle Type:", error);
      const msg =
        error.response?.data?.message ||
        error.message ||
        "Error saving Vehicle Type";

      if (msg.toLowerCase().includes("duplicate")) {
        showMessage("Duplicate Vehicle Type Name!", "error");
      } else {
        showMessage(msg, "error");
      }
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate("/cpnl/vehicletype/view");
  };

  return (
    <>
      <Breadcrumb
        pageTitle={editMode ? "Modify Vehicle Type" : "Add Vehicle Type"}
        secondTitle="Masters"
      />

      {/* {message && (
        <div
          className={`alert ${msgType === "success" ? "alert-success" : "alert-danger"
            } d-flex justify-content-between align-items-center mb-3 p-2`}
        >
          <span>{message}</span>
          <button type="button" className="btn-close" onClick={closeMessage} />
        </div>
      )} */}

        <MessageDialog
          message={message}
          type={msgType}
          setMessage={setMessage}
          setMsgType={setMsgType}
        />
      

      <div className="row">
        <div className="card py-2 bg-white shadow-sm">
          {editLoading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary"></div>
              <div className="mt-2 text-muted">Loading data...</div>
            </div>
          ) : (
            <form onSubmit={handleSubmit(onSubmit)}>
              <div className="row mb-3">
                <div className="col-md-6 mb-3">
                  <label className="form-label">
                    Vehicle Type <span className="text-danger">*</span>
                  </label>
                  <input
                    type="text"
                    className={`form-control ${errors.vehicleType ? "is-invalid" : ""
                      }`}
                    {...register("vehicleType", {
                      required: "Vehicle Type is required",
                    })}
                    disabled={loading}
                  />
                  {errors.vehicleType && (
                    <small className="text-danger">
                      {errors.vehicleType.message}
                    </small>
                  )}
                </div>
              </div>

              <div>
                <button
                  type="submit"
                  className="btn btn-primary btn-sm me-2"
                  disabled={loading}
                >
                  <i className="ti ti-circle-check me-1"></i>
                  {loading
                    ? editMode
                      ? "Updating..."
                      : "Saving..."
                    : editMode
                      ? "Update"
                      : "Save"}
                </button>

                <button
                  type="button"
                  className="btn btn-secondary btn-sm"
                  onClick={handleCancel}
                  disabled={loading}
                >
                  <i className="ti ti-cancel me-1"></i>
                  Cancel
                </button>
              </div>
            </form>
          )}
        </div>
      </div>
    </>
  );
}
